import RuleActionModel from '@/common/models/rules/actions/rule-action-model';

export default class ShowDescriptorDisclaimerActionModel extends RuleActionModel {
    hydrate(fields = {}) {
        super.hydrate(fields);
        ({
            buttonText: this.buttonText = null,
            disclaimerText: this.disclaimerText = null,
            returnLinkText: this.returnLinkText = null,
        } = fields);
    }

    getPayload() {
        return {
            ...super.getPayload(),
            buttonText: this.buttonText,
            disclaimerText: this.disclaimerText,
            returnLinkText: this.returnLinkText,
        };
    }
}
